export default __webpack_public_path__ + "static/media/icon-unlock.7c9b0859.svg";